import register from '../util/register'
import angular from 'angular'
import Record from './Record'
import RecordQueryService from './RecordQueryService'
import RecordMapService from './RecordMapService'
import RelatedDocuments from './RelatedDocuments'
import 'angular-resource'

var records = angular.module(
  'app.records',
  [
    'ngResource',
    'angular-md5'
  ])

register('app.records')
  .service('RecordQueryService', RecordQueryService)
  .service('RecordMapService', RecordMapService)
  .factory('Record', Record.factory)
  .factory('RelatedDocuments', RelatedDocuments.factory)

records.run()
